import { useTranslation } from 'react-i18next';
import { StatusChip } from '@munifocus/ui';
import type { ShiftHandoverDto } from '@munifocus/contracts-gov';
import { handoverStatus } from './handover-display';

export function HandoverStatusChip({ handover }: { handover: ShiftHandoverDto }) {
  const { t } = useTranslation();
  const status = handoverStatus(handover);
  return (
    <StatusChip
      status={status === 'acknowledged' ? 'success' : status === 'pending' ? 'pending' : 'neutral'}
      label={t(`gov.teamwork.handovers.status.${status}`)}
    />
  );
}
